import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FacultyDepartmentListComponent } from './faculty-department-list/faculty-department-list.component';
import { FacultyDepartmentCreateComponent } from './faculty-department-create/faculty-department-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: FacultyDepartmentListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: FacultyDepartmentCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'faculty-department-create/:id',
        component: FacultyDepartmentCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FacultyDepartmentRoutingModule { }
